import { i18n } from '@/plugins/i18n'

export const settlementRequestStatus = {
    PENDING:    0,
    CANCELLED:  1,
    DONE:       2,
    PROCESSING: 3,
};

export const settlementRequestStatusStr = {
    PENDING:    i18n.t('settlement_request_status.pending'),
    CANCELLED:  i18n.t('settlement_request_status.cancelled'),
    DONE:       i18n.t('settlement_request_status.done'),
    PROCESSING: i18n.t('settlement_request_status.processing'),

    get(status) {
        let status_str = null;

        Object.keys(settlementRequestStatus).forEach(item => {
            if(settlementRequestStatus[item] === status) {
                status_str = settlementRequestStatusStr[item];
            }
        });

        return status_str;
    }
};

export const settlementRequestStatusVariant = (status) => {
    if(status === settlementRequestStatus.DONE) {
        return 'success';
    }

    if(status === settlementRequestStatus.PENDING) {
        return 'primary';
    }

    if(status === settlementRequestStatus.PROCESSING) {
        return 'warning';
    }

    if(status === settlementRequestStatus.CANCELLED) {
        return 'danger';
    }

    return 'secondary';
};
